.formRefinementContainer {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
}

.label {
  font-size: var(--cxy-fontSize-s);
  margin-top: var(--cxy-spacing-2);
}

.resetButton {
  align-self: center;
}
